<script>
  import Logo from './Logo.svelte';
</script>

<div>
  <Logo />
</div>

<style>div{-webkit-animation:spin .6s ease infinite alternate;animation:spin .6s ease infinite alternate}@-webkit-keyframes spin{0%{transform:rotateY(0deg)}to{transform:rotateY(180deg)}}@keyframes spin{0%{transform:rotateY(0deg)}to{transform:rotateY(180deg)}}</style>
